<template>
  <div class="produce-search">
    <div class="top-search">
      <div class="top-search-content">
        <el-input 
          class="white"
          prefix-icon="el-icon-search" 
          v-model="searchOrderCode" 
          :placeholder="`请输入${typeName}`"
          @keyup.enter.native="search"
        >
          <span slot="prefix" class="select-order">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ typeName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="beforeHandleCommand(1, 'orderCode')">订单号</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(2, 'expressCode')">运单号</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </el-input>
        <el-button class="btn-blue" @click="search">搜索</el-button>
      </div>
    </div>

    <div class="order-details" v-if="!isShowNothing">
      <div class="order-info">
        <p class="sub-title">订单信息</p>
        <div class="info-content">
          <div class="row">
            <span class="title">订单号</span>
            <span class="title-content">{{ orderInfo.orderCode }}</span>
          </div>
          <div class="row">
            <span class="title">接单时间</span>
            <span class="title-content">{{ orderInfo.receivingOrdersTime }}</span>
          </div>
          <div class="row">
            <span class="title">出库时间</span>
            <span class="title-content">{{ orderInfo.outboundTime }}</span>
          </div>
          <div class="row">
            <span class="title">商品总数</span>
            <span class="title-content">{{ orderInfo.goodsNums }}（个）</span>
          </div>
          <div class="row">
            <div class="title">订单商品</div>
            <div class="goods-datails-content">
              <div
                class="goods-datails"
                v-for="(item, index) in orderInfo.goodsDetails"
                :key="index"
              >
                <tool-tip v-bind="{txtInfo:item}">
                </tool-tip>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="title">包裹信息</div>
            <div class="goods-datails-content">
              <div
                class="goods-datails express-info"
                v-for="(item, index) in orderInfo.expressList"
                :key="index"
              >
                <span class="express-no">{{ item.expressNo }}</span>
                <span class="order-weight">{{ item.orderWeight }}（kg）</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="participant-info">
        <p class="sub-title">参与者信息</p>
        <div class="info-content">
          <div 
            class="row"
            v-for="(item, index) in participantList"
            :key="index"
          >
            <div class="row-info row-info1">
              <img class="row-img" src="~assets/images/team/user2.png">
              <span>{{ item.name }}</span>
            </div>
            <div class="row-info row-info2">
              <img class="row-img" src="~assets/images/team/call.png">
              <span v-if="item.phone">{{ item.phone }}</span>
              <span v-else class="no-teams">无班组信息</span>
            </div>
            <div class="row-info row-info3">
              <img v-if="item.type == 1" class="headman-blue" src="~assets/images/product/headman-blue.png">
              <img v-if="item.type == 9" class="check-accept" src="~assets/images/product/check-accept.png">
            </div>
          </div>
        </div>
      </div>
      <div class="video-info">
        <p class="sub-title">视频信息</p>
        <div class="info-content">
          <div class="nothing">
            <img class="nothing-null" src="~assets/images/nothing/nothing-null.png">
            <p>待接入</p>
          </div>
        </div>
      </div>
    </div>

    <div class="nothing-content" v-else>
      <img class="nothing-img" src="~assets/images/nothing/nothing.png">
    </div>
  </div>
</template>

<script>
import toolTip from '@/components/base/toolTip.vue'
import ProduceSearch from "models/production/produce-search";
export default {
  components: { 
    toolTip 
  },
  data() {
    return {
      // 1 、系统单号，2、运单号
      type: 1,
      typeName: '订单号',
      searchOrderCode: '',
      orderInfo: {
        orderCode: '',
        expressList: [],
        receivingOrdersTime: '',
        outboundTime: '',
        goodsNums: null,
        goodsDetails: []
      },
      // 验货员
      inspector: '',
      participantList: [],
      isShowNothing: true
    }
  },

  created() {
    this.initOrderInfo()
  },

  methods: {
    search() {
      this.initOrderInfo()
    },

    initOrderInfo() {
      let code = this.searchOrderCode
      let type = this.type
      let data = {
        code,
        type
      }
      ProduceSearch.getProduceSearchOrderDetaile(data).then(res => {
        if (res.success) {
          if (res.result) {
            let { 
              systemOrderNo, expressList, inspector, warehouseOrderTime, 
              outboundTime, goodsQuantity, skuName, teamMemberList 
            } = res.result
            this.orderInfo.orderCode = systemOrderNo
            this.orderInfo.expressList = expressList
            this.orderInfo.receivingOrdersTime = warehouseOrderTime
            this.orderInfo.outboundTime = outboundTime
            this.orderInfo.goodsNums = goodsQuantity
            this.orderInfo.goodsDetails = skuName
            
            // 参与者信息集合
            let arr = [];
            if (teamMemberList.length) {
              teamMemberList.map((i) => {
                let obj = {};
                obj.name = i.memberName;
                obj.phone = i.phoneNumber
                // 1: 组长；0：组员
                obj.type = i.isLeader
                arr.push(obj);
              });
            } else {
              // 验货员信息
              let inspectorObj = {
                name: inspector,
                phone: '',
                // 自定义验货员类型为9
                type: 9
              }
              arr.push(inspectorObj);
            }
            this.participantList = arr;
            this.isShowNothing = false
          } else {
            this.orderInfo = {
              orderCode: '',
              expressList: [],
              receivingOrdersTime: '',
              outboundTime: '',
              goodsNums: null,
              goodsDetails: []
            }
            // 验货员
            this.inspector = ''
            this.participantList = []
            this.isShowNothing = true
          }
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value, command){
      return {
        'value': value,
        'command':command,
      }
    },

    handleCommand(command) {
      switch (command.command) {
        case "orderCode":
          this.type = command.value
          this.typeName = '订单号'
        break;
        case "expressCode":
          this.type = command.value
          this.typeName = '运单号'
        break;
      }
    },
  }
}
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/produce-search.scss";
</style>
